var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rate-item", class: [{ selected: _vm.isSelected }] },
    [
      _c("div", { staticClass: "rate-title" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.rate.title || "Our best rate")),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rate-view-more" }, [
          _c(
            "a",
            {
              attrs: { tabindex: "0" },
              on: {
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.$emit("select", _vm.rate)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.$emit("select", _vm.rate)
                  },
                ],
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("select", _vm.rate)
                },
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.tc("booking.seeDetails")) + "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rate-description" }, [
        _c("div", { staticClass: "rate-info" }, [
          _c("div", { staticClass: "description" }, [
            _vm._v("\n        " + _vm._s(_vm.rateDescription) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "rate-view-more" }, [
            _c(
              "a",
              {
                attrs: { tabindex: "0" },
                on: {
                  keydown: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.$emit("select", _vm.rate)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.$emit("select", _vm.rate)
                    },
                  ],
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("select", _vm.rate)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.tc("booking.seeDetails")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rate-cta-wrapper" }, [
          _c("div", { staticClass: "rate-price" }, [
            _c("div", { staticClass: "price" }, [
              _c("span", [_vm._v(_vm._s(_vm.ratePrice))]),
              _vm._v(" "),
              _c("span", { staticClass: "price-label" }, [
                _vm._v(_vm._s(_vm.tc("booking.perNight"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "rate-cta",
              class: [{ "is-selecting": _vm.isLoading }],
            },
            [
              _c(
                "button",
                {
                  class: [{ loading: _vm.isLoading }],
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: _vm.doCartAction,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.doCartAction($event)
                    },
                  },
                },
                [
                  !_vm.isLoading
                    ? _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              !_vm.isSelected
                                ? _vm.tc("booking.bookThisRate")
                                : _vm.tc("booking.keepThisRate")
                            ) +
                            "\n          "
                        ),
                      ])
                    : _c("loading-dots"),
                ],
                1
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }